import React, { forwardRef } from 'react';

import Dropdown, {
  IDropdownProps,
} from '@/components/common/Dropdown/Dropdown';
import ValidationAlert from '@/components/common/ValidationAlert/ValidationAlert';
import Skeleton from '../Skeleton/Skeleton';

import styles from './contract-input.module.scss';
import { POUND_STERLING_CODE } from '@/config/common.config';

interface IContractDropdownHeaderItemProps<OptionType>
  extends IDropdownProps<OptionType> {
  label: string;
  labelClassName?: string;
  required?: boolean;
  errorMessage?: any;
  isLoadingContractDetails?: boolean;
}

function ContractDropdownHeaderItemInner<OptionType>(
  props: IContractDropdownHeaderItemProps<OptionType>,
  ref?: React.Ref<any>
) {
  const {
    id,
    label,
    labelClassName,
    placeholder,
    required = false,
    errorMessage,
    getOptionLabel,
    getFormatOptionLabel,
    getOptionValue,
    handleChange,
    handleInputChange,
    optionsData,
    isLoading,
    isSearchable,
    isClearable,
    needToShowInputTextOnBlur,
    name,
    selectedOption,
    isLoadingContractDetails,
    disabled,
  } = props;

  const optionsDataWithPoundFirst = optionsData?.reduce((options: OptionType[], option: any) => {
    return option.numericCode === POUND_STERLING_CODE ? [option, ...options] : [...options, option];
  }, []);


  return (
    <div>
      <div className={styles['ag-contract-input']}>
        <label className={labelClassName ?? styles.label} htmlFor={id}>
          {`${label} `}
          {required && <span>*</span>}
        </label>

        {isLoadingContractDetails && (
          <Skeleton count={1} />
        )}
        {!isLoadingContractDetails && <div className={styles.wrapper}>
          <Dropdown<OptionType>
            ref={ref}
            id={id}
            placeholder={placeholder}
            isLoading={isLoading}
            getOptionLabel={getOptionLabel}
            getFormatOptionLabel={getFormatOptionLabel}
            getOptionValue={getOptionValue}
            handleChange={handleChange}
            handleInputChange={handleInputChange}
            optionsData={optionsDataWithPoundFirst}
            isSearchable={isSearchable}
            isClearable={isClearable}
            needToShowInputTextOnBlur={needToShowInputTextOnBlur}
            name={name}
            selectedOption={selectedOption}
            disabled={disabled}
          />
        </div>}
      </div>
      {errorMessage ? (
        <ValidationAlert isFloating={false} type="danger">
          <>{errorMessage}</>
        </ValidationAlert>
      ) : null}
    </div>
  );
}

// eslint-disable-next-line max-len
const ContractDropdownHeaderItem = forwardRef(ContractDropdownHeaderItemInner) as <OptionType>(props: IContractDropdownHeaderItemProps<OptionType>) => JSX.Element;

export default ContractDropdownHeaderItem;
